import { render, staticRenderFns } from "./TabsOptions.vue?vue&type=template&id=4895f754&scoped=true"
import script from "./TabsOptions.vue?vue&type=script&lang=js"
export * from "./TabsOptions.vue?vue&type=script&lang=js"
import style0 from "./TabsOptions.vue?vue&type=style&index=0&id=4895f754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4895f754",
  null
  
)

export default component.exports